import React, { useState } from 'react';
import { Fab, Badge, Tooltip, Zoom } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import AIIcon from '../../../assets/svgs/AI-Icon.svg';

const StyledFab = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})(({ theme, isOpen }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(8.5),
  [theme.breakpoints.down('sm')]: {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  zIndex: 1300,
  backgroundColor: isOpen ? theme.palette.error.main : theme.palette.primary.main,
  color: 'white',
  transition: 'all 0.3s ease-in-out',
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  '&:hover': {
    backgroundColor: isOpen ? theme.palette.error.dark : theme.palette.primary.dark,
    transform: isOpen ? 'rotate(180deg) scale(1.1)' : 'scale(1.1)',
  },
  '&.pulse': {
    animation: 'pulse 2s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.7)',
    },
    '70%': {
      transform: 'scale(1.05)',
      boxShadow: '0 0 0 10px rgba(25, 118, 210, 0)',
    },
    '100%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(25, 118, 210, 0)',
    },
  },
}));

const AiChatFloatButton = ({ 
  onClick, 
  isOpen = false, 
  unreadCount = 0, 
  disabled = false,
  showPulse = false,
  tooltipText = "AI Assistant - Ask questions about this page"
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <Zoom in={true} timeout={300}>
      <Tooltip 
        title={disabled ? "AI Assistant unavailable" : tooltipText}
        placement="left"
        arrow
      >
        <span>
          <StyledFab
            color="primary"
            aria-label="ai-chat"
            onClick={handleClick}
            disabled={disabled}
            isOpen={isOpen}
            className={showPulse && !isOpen ? 'pulse' : ''}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            size="small"
          >
            <Badge 
              badgeContent={unreadCount > 0 ? unreadCount : null} 
              color="error"
              overlap="circular"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {isOpen ? (
                <CloseIcon 
                  sx={{ 
                    fontSize: 28,
                    transition: 'transform 0.2s ease-in-out',
                    transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                  }} 
                />
              ) : (
                <AIIcon 
                  sx={{ 
                    fontSize: 28,
                    transition: 'transform 0.2s ease-in-out',
                    transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                  }} 
                />
              )}
            </Badge>
          </StyledFab>
        </span>
      </Tooltip>
    </Zoom>
  );
};

export default AiChatFloatButton;
